function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
var classPrefix = "dffl-icon";

var insertIntoBody = function insertIntoBody(element) {
  var firstChild = document.body.firstChild;

  if (firstChild) {
    var _firstChild$parentNod;

    (_firstChild$parentNod = firstChild.parentNode) === null || _firstChild$parentNod === void 0 ? void 0 : _firstChild$parentNod.insertBefore(element, firstChild);
  } else {
    document.body.appendChild(element);
  }
};

var hasInjectStyle = false;

var injectStyle = function injectStyle() {
  if (hasInjectStyle) {
    return;
  }

  hasInjectStyle = true;
  var style = document.createElement('style');
  style.innerHTML = ".".concat(classPrefix, " {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}");
  insertIntoBody(style);
};

var customCache = new Set();

function isValidCustomScriptUrl(scriptUrl) {
  return Boolean(typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl));
}

function createScriptUrlElements(scriptUrls) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var currentScriptUrl = scriptUrls[index];

  if (isValidCustomScriptUrl(currentScriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', currentScriptUrl);
    script.setAttribute('data-namespace', currentScriptUrl);

    if (scriptUrls.length > index + 1) {
      script.onload = function () {
        createScriptUrlElements(scriptUrls, index + 1);
      };

      script.onerror = function () {
        createScriptUrlElements(scriptUrls, index + 1);
      };
    }

    customCache.add(currentScriptUrl);
    document.body.appendChild(script);
  }
}

export default function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var scriptUrl = options.scriptUrl,
      _options$extraCommonP = options.extraCommonProps,
      extraCommonProps = _options$extraCommonP === void 0 ? {} : _options$extraCommonP;
  /**
   * DOM API required.
   * Make sure in browser environment.
   * The Custom Icon will create a <script/>
   * that loads SVG symbols and insert the SVG Element into the document body.
   */

  if (scriptUrl && typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function') {
    if (Array.isArray(scriptUrl)) {
      // 因为iconfont资源会把svg插入before，所以前加载相同type会覆盖后加载，为了数组覆盖顺序，倒叙插入
      createScriptUrlElements(scriptUrl.reverse());
    } else {
      createScriptUrlElements([scriptUrl]);
    }
  }

  var Iconfont = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var type = props.type,
        className = props.className,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        fontSize = props.fontSize,
        color = props.color;
    injectStyle();
    var mergeStyle = style;

    if (extraCommonProps.style) {
      mergeStyle = Object.assign({}, extraCommonProps.style, style);
    }

    if (fontSize) {
      mergeStyle.fontSize = fontSize;
    }

    if (color) {
      mergeStyle.color = color;
    }

    return /*#__PURE__*/React.createElement("svg", _extends({}, extraCommonProps, {
      className: [classPrefix, extraCommonProps.className, className].filter(Boolean).join(' '),
      style: mergeStyle,
      "aria-hidden": "true",
      ref: ref
    }), /*#__PURE__*/React.createElement("use", {
      xlinkHref: "#".concat(type)
    }));
  });
  Iconfont.displayName = 'DfflIcon';
  return Iconfont;
}